export default __webpack_public_path__ + "static/media/VideoGames.6802f62c.svg";